import { InjectionToken } from '@angular/core';

export const API_ENDPOINT = new InjectionToken('API_ENDPOINT');
export const WS_ENDPOINT = new InjectionToken('WS_ENDPOINT');
